import _Vue from "vue";
import Dialog from "./dialog";

const install = (Vue: typeof _Vue) => {
  const dialog = new Dialog();
  Vue.prototype.$dialog = dialog;
  (Vue as any).$dialog = dialog;
}
  
  const plugin = {
      install
  }
  
  export default plugin
